import React from 'react';
import { useI18n } from '@/lib/i18n';

const IMG = 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1800&q=80';

export default function ProjectsGrowth() {
  const { t } = useI18n();
  const marquee = [...t.growth.marquee, ...t.growth.marquee];
  return (
    <section id="growth" data-testid="growth-section" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative aspect-[5/4]">
            <div className="absolute -top-4 -left-4 w-full h-full border border-[#C5A059]/40" />
            <div
              className="relative w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${IMG})` }}
            />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="eyebrow text-[#C5A059] flex items-center gap-3">
            <span className="w-10 h-px bg-[#C5A059]" />
            {t.growth.eyebrow}
          </div>
          <h2 className="heading-display mt-6 text-[#0A1128] text-3xl sm:text-4xl lg:text-5xl">{t.growth.title}</h2>
          <p className="mt-8 text-[#1E2229]/75 text-lg leading-relaxed max-w-lg">{t.growth.body}</p>

          <div className="mt-10 flex flex-wrap gap-3">
            {t.growth.tags.map((tag, i) => (
              <span
                key={i}
                data-testid={`growth-tag-${i}`}
                className="px-4 py-2 border border-[#E2E8F0] text-[#0A1128] text-[11px] tracking-[0.22em] uppercase font-semibold hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-y border-[#E2E8F0] bg-[#F8F9FA] overflow-hidden py-7">
        <div className="flex animate-marquee whitespace-nowrap gap-12 text-[#0A1128]/60">
          {marquee.map((m, i) => (
            <span key={i} className="font-display text-2xl tracking-tight flex items-center gap-12">
              {m}
              <span className="text-[#C5A059]">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
